module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper",
    attrs: {
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "block-center mt-xl wd-xl"
  }, [_c('div', {
    staticClass: "panel panel-dark panel-flat"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "img-container"
  }, [_c('svg', {
    attrs: {
      "width": "151",
      "height": "144",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "fill-rule": "nonzero",
      "fill": "none"
    }
  }, [_c('path', {
    attrs: {
      "d": "M11 122h79v10H7c-3 0-5-3-5-5V7c0-3 2-5 5-5h138c3 0 5 2 5 5v78h-9V11H11v111z",
      "fill": "#E2E2E2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M7 39v-9h138v9H7zm14-14v-9h9v9h-9zm18 0v-9h9v9h-9z",
      "fill": "#E2E2E2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M9 120h79v10H5c-3 0-5-2-5-5V5c0-3 2-5 5-5h138c3 0 5 2 5 5v78h-9V9H9v111z",
      "fill": "#00788D"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5 37v-9h138v9H5zm14-14v-9h9v9h-9zm18 0v-9h9v9h-9z",
      "fill": "#00788D"
    }
  }), _vm._v(" "), _c('g', [_c('path', {
    attrs: {
      "d": "M133.9321616 86.51651217h-16.336519v5.44550635h16.336519v-5.44550635zm-10.8910127 35.39579123h5.4455064v-16.336519h-5.4455064v16.336519zm21.8500942-18.0110122l3.8799233-3.8799233c-1.1707838-1.4022179-2.4504778-2.6819119-3.8526957-3.8526957l-3.8799233 3.8799233c-4.1794261-3.3489865-9.5024086-5.3638238-15.2882591-5.3638238-13.545697 0-24.49116478 10.9726953-24.49116478 24.5047786 0 13.5320833 10.94546778 24.5047785 24.49116478 24.5047785 13.5456971 0 24.5183924-10.9726952 24.5183924-24.5047785 0-5.7858505-2.0148374-11.0952192-5.3774376-15.2882591zm-19.127341 34.3475313c-10.523441 0-19.05927223-8.5358312-19.05927223-19.0592722 0-10.523441 8.53583123-19.0592723 19.05927223-19.0592723 10.523441 0 19.0592722 8.5358313 19.0592722 19.0592723s-8.5358312 19.0592722-19.0592722 19.0592722z",
      "fill": "#E2E2E2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M131.9321616 84.51651217h-16.336519v5.44550635h16.336519v-5.44550635zm-10.8910127 35.39579123h5.4455064v-16.336519h-5.4455064v16.336519zm21.8500942-18.0110122l3.8799233-3.8799233c-1.1707838-1.4022179-2.4504778-2.6819119-3.8526957-3.8526957l-3.8799233 3.8799233c-4.1794261-3.3489865-9.5024086-5.3638238-15.2882591-5.3638238-13.545697 0-24.49116478 10.9726953-24.49116478 24.5047786 0 13.5320833 10.94546778 24.5047785 24.49116478 24.5047785 13.5456971 0 24.5183924-10.9726952 24.5183924-24.5047785 0-5.7858505-2.0148374-11.0952192-5.3774376-15.2882591zm-19.127341 34.3475313c-10.523441 0-19.05927223-8.5358312-19.05927223-19.0592722 0-10.523441 8.53583123-19.0592723 19.05927223-19.0592723 10.523441 0 19.0592722 8.5358313 19.0592722 19.0592723s-8.5358312 19.0592722-19.0592722 19.0592722z",
      "fill": "#8C1D1D"
    }
  })])])])]), _vm._v(" "), _c('p', {
    staticClass: "lead"
  }, [_vm._v(_vm._s(_vm.errorDescription))]), _vm._v(" "), (_vm.resetPassword) ? _c('div', [_vm._m(1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-lg mt-lg",
    on: {
      "click": _vm.goToResetPassword
    }
  }, [_vm._v("Reset password")])]) : _vm._e(), _vm._v(" "), (_vm.emailConfirmation) ? _c('div', [_vm._m(2), _vm._v(" "), (!_vm.sentEmailConfirmation) ? _c('div', [_c('button', {
    staticClass: "btn btn-default btn-lg mt-lg",
    on: {
      "click": _vm.resendEmailVerification
    }
  }, [_vm._v("Confirm email")])]) : _vm._e(), _vm._v(" "), (_vm.sentEmailConfirmation) ? _c('div', [_vm._m(3), _vm._v(" "), _c('p', [_vm._v("Email sent. Please check your email.")])]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _vm._m(4)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading text-center"
  }, [_c('img', {
    staticClass: "block-center",
    attrs: {
      "src": require("../assets/calvert-logo.png"),
      "alt": "Image",
      "width": "180"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("The reset password link you were trying to enter is not available anymore. "), _c('br'), _vm._v("Please, try again.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("The email confirmation link you were trying to enter is not available anymore. "), _c('br'), _vm._v("Please, try again.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "/#/login"
    }
  }, [_c('button', {
    staticClass: "btn btn-default btn-lg mt-lg"
  }, [_vm._v("Go to login")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "mt-lg"
  }, [_vm._v("If you need more help, please contact Calvert Impact Capital at "), _c('a', {
    attrs: {
      "href": "mailto:info@calvertimpact.org"
    }
  }, [_vm._v("info@calvertimpact.org")]), _vm._v(" or call us at 800-248-0337.")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6fe2335e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ErrorAuth.vue
// module id = 2168
// module chunks = 1